"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
function AccordionItem({ children, className, expanded, heading, id }) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h2", { className: "usa-accordion__heading", children: (0, jsx_runtime_1.jsx)("button", { className: "usa-accordion__button", type: "button", "aria-expanded": expanded, "aria-controls": id, children: heading }) }), (0, jsx_runtime_1.jsx)("div", { id: id, className: (0, uswds_react_utils_1.createClassString)('usa-accordion__content', className), children: children })] }));
}
exports.default = AccordionItem;
